import { show } from '@intercom/messenger-js-sdk';

const setting = {
  color: {
    // Static hex required by the Intercom SDK (renders in its own iframe and
    // cannot resolve our CSS variables). Must match --color-green-400 (#008053).
    theme: '#008053',
    launcher: '#008053',
    launcherText: '#FFF',
  },
  launcher: {
    chatLabel: {
      'en-US': 'Need Help',
    },
  },
};

const SupportForm = {
  setting,
  openForm: (): void => {
    show();
  },
  /* Not implemented */
  prefill: (fields: Record<string, unknown>): void => {},
};

export default SupportForm;
